import React from 'react';
import PropTypes from 'prop-types';
import TextEdit from 'components/SharedComponents/Inline/text-edit';
import config from 'config';
import classNames from 'classnames';

export default class InlineEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            characterEntered: 0,
            showEditTitleIcon: false,
            editTitleFocus: false,
            errorInTitleMaxLengthExceeded: false,
            errorInTitle: false,
            invalidCharacters: false
        };
    }

    titleChanged(data) {
        const id = Object.keys(data)[0];
        const title = data[id];
        this.props.editText(id, title);
    }

    textValidate(text, e) {
        this.setState({ characterEntered: text.length});
        const regex = this.props.regex;
        if (text.length > this.props.maxlength) {
            this.setState({
                errorInTitleMaxLengthExceeded: true,
                errorInTitle: false,
                invalidCharacters: false
            });
            return false;
        } else if (text.length < this.props.minLength) {
            this.setState({
                errorInTitle: true,
                errorInTitleMaxLengthExceeded: false,
                invalidCharacters: false
            });
            return false;
        } else if (this.props.characterCheckRequired
            && this.testRegEx(regex, text) === true) {
            this.setState({
                invalidCharacters: true,
                errorInTitleMaxLengthExceeded: false,
                errorInTitle: false
            });
            return false;
        }
        this.setState({
            errorInTitleMaxLengthExceeded: false,
            errorInTitle: false,
            invalidCharacters: false
        });
        return true;
    }

    manipulate(text) {
        this.setState({
            characterEntered: text.length,
            editTitleFocus: true,
            showEditTitleIcon: false
        });
    }

    staticMouseover() {
        this.setState({showEditTitleIcon: true});
    }

    staticMouseleave() {
        this.setState({showEditTitleIcon: false});
    }

    titleEditBlur() {
        this.setState({
            showEditTitleIcon: false,
            editTitleFocus: false,
            errorInTitleMaxLengthExceeded: false,
            errorInTitle: false
        });
    }

    testRegEx(re, str) {
        if (re.test(str)) {
            return true;
        }
        return false;
    }

    render() {
        const errorClass = classNames({
            'inline-edit--length__error': this.state.errorInTitle || this.state.errorInTitleMaxLengthExceeded
        });
        const {t} = this.props;
        return (
            <div className="inline-edit">
                {
                  this.state.showEditTitleIcon ?
                      <img className="inline-edit--edit-title-img" src={`${config.assets.url}/images/catalog/edit-btn.png`} alt="" />
                    : ''
                }
                <TextEdit
                  id={`inline-edit--${this.props.id}`}
                  className="inline-edit--edit"
                  activeClassName="inline-edit--active"
                  text={this.props.text}
                  paramName={this.props.id}
                  change={this.titleChanged.bind(this)}
                  validate={this.textValidate.bind(this)}
                  staticStateClick={this.manipulate.bind(this)}
                  onblur={this.titleEditBlur.bind(this)}
                  maxLength={this.props.maxlength + 1}
                  staticMouseover={this.staticMouseover.bind(this)}
                  staticMouseleave={this.staticMouseleave.bind(this)}
                  editingElement={this.props.editingElement}
                  placeholder={this.props.placeholder}
                  stopPropagation={this.props.stopPropogation || false}
                />
              {
                this.state.editTitleFocus ?
                    <div className={`inline-edit--length ${errorClass}`}>{this.state.characterEntered}/{this.props.maxlength}</div>
                  : ''
              }
              {
                this.state.editTitleFocus && this.state.errorInTitle ?
                    <div className="inline-edit--inline-error">{t('channel.edit-recording-title.inline-error')}</div>
                  : ''
              }
              {
                this.state.editTitleFocus && this.state.errorInTitleMaxLengthExceeded ?
                    <div className="inline-edit--inline-error">
                        {t('channel.edit-recording-title.inline-error-max')}
                    </div>
                  : ''
              }
              {
                this.state.editTitleFocus &&
                this.state.invalidCharacters ?
                    <div className="inline-edit--inline-error">
                        {t('channel.edit-title.inline-error')}
                    </div>
                   : ''
              }
            </div>
        );
    }
}

InlineEdit.propTypes = {
    maxlength: PropTypes.number,
    minLength: PropTypes.number,
    t: PropTypes.func,
    editingElement: PropTypes.string,
    editText: PropTypes.func,
    id: PropTypes.string,
    text: PropTypes.string,
    characterCheckRequired: PropTypes.bool,
    placeholder: PropTypes.string,
    regex: PropTypes.object,
    stopPropogation: PropTypes.bool
};

InlineEdit.defaultProps = {
    characterCheckRequired: false,
    minLength: 1,
    maxlength: 256,
    regex: /\[|\]|\{|\}+/
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/Inline/inline-edit.js